module.exports = __webpack_public_path__ + "static/media/carolus-classic.964d7f2e.jpg";